<template>
  <controller>
    <page-header title="Calculadora de Preços"/>
    <section class="calculadora">
      <simulador v-if="plano" :scope="plano" @onClose="toggleSimulator(null)" @onProposta="toggleProposta"/>
      <planos-pagamento :scope="planos" v-if="planos" @onSelect="toggleSimulator"/>
    </section>
  </controller>
</template>

<script>
import MatriculaService from '@/services/matricula.service.js'
import PlanosPagamento from '@/components/matriculas/simulador/PlanosPagamento.vue'
import Simulador from '@/components/matriculas/simulador/Simulador.vue'

export default {
  components: {
    PlanosPagamento, Simulador,
  },
  props: {
    idSerie: {
      type: [Number, String]
    },
    idFuncao: {
      type: [Number, String]
    },
    tipoMatricula: {
      type: [Number, String]
    }
  },
  data () {
    return {
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
      planos: null,
      plano: null,
      proposta: null
    }
  },
  mounted () {
    this.getPlanos()

    this.$store.dispatch('propostaValores/get').then(response => {
      this.proposta = response
    })
  },
  methods: {
    getPlanos () {
      const options = {
        idSerie: this.idSerie,
        idFuncao: this.idFuncao,
        tipoMatricula: this.tipoMatriculas
      }
      MatriculaService.getPlanosBySerie(options).then(
        response => {
          console.log('getPlanosBySerie:', response.data)
          const clearPlanos = response.data.filter( a => a.planosPagamento)
          this.planos = MatriculaService.processPlanos(clearPlanos)
          console.log('planos:', this.planos)
        },
        () => {
          
        }
      )
    },
    toggleSimulator ( plano ) {
      this.plano = plano
    },
    toggleProposta ( proposta ) {
      const drop = JSON.stringify(proposta)
      localStorage.setItem('proposta', drop)
      
      const routeData = this.$router.resolve({name: 'proposta_valores'})
      window.open(routeData.href, '_blank')
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .calculadora {
    width: 100%;
  }
</style>